import { z } from 'zod';
import { OrganizationSchema } from '../../entities/organization/organization.schema';
/**
 * Show Organization Response Schema
 * GET /api/v2/organization
 * Returns organization entity from backend
 */ export const ShowOrganizationResponseSchema = z.object({
    data: OrganizationSchema
});

//# sourceMappingURL=show-organization.schema.js.map